module.exports = __webpack_public_path__ + "img/icon16-call-internal-success.7db1ca88.svg";